import React from 'react';
import Chip from '@mui/material/Chip';

export const TYPE_LABELS = {
  bug: 'Бага',
  feature: 'Предложение',
  unknown: 'Неизвестно',
};

// Outlined, чтобы тип не спорил за внимание со статусом и приоритетом,
// которые залиты цветом.
const TYPE_COLORS = {
  bug: '#d32f2f',
  feature: '#7b1fa2',
  unknown: '#9e9e9e',
};

export default function TypeChip({ type }) {
  const key = TYPE_LABELS[type] ? type : 'unknown';

  return (
    <Chip
      label={TYPE_LABELS[key]}
      size="small"
      variant="outlined"
      sx={{
        borderColor: TYPE_COLORS[key],
        color: TYPE_COLORS[key],
        fontWeight: 500,
        textTransform: 'none',
        letterSpacing: 0,
      }}
    />
  );
}
